module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./AfterSaleDetailView.js"));
	}, "AfterSaleDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AfterSaleDetailView!./src/pages/Shop/Member/TradeManage/AfterSale/AfterSaleDetail/AfterSaleDetailView.js
// module id = 1549
// module chunks = 418